<template>
  <div class="reviewer">
    <table-list
      title="阅卷人管理"
      :loading="loading"
      :data="reviewerList"
      :columns="columns(this)"
      :btns="btns(this)"
      :operates="operates(this)"
      :options="{ selection: true, operatesWidth: 160 }"
      @selectionChange="handleSelectionChange"
    ></table-list>
    <el-dialog title="编辑" :visible.sync="editVisible" width="560px">
      <el-form :model="form" label-width="120px">
        <el-form-item label="姓名：">
          <el-input v-model="form.name" disabled placeholder="请输入考试试卷名称"></el-input>
        </el-form-item>
        <el-form-item label="适用职业/工种：">
          <el-select v-model="form.jobWorkTypeTag" multiple placeholder="请选择类型">
            <el-option
              v-for="item in jobWorkTypeList"
              :key="item.tag"
              :label="item.jobWorkType"
              :value="item.tag"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <AssignSubject ref="AssignSubject" />
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '添加',
    method: _this.handleAdd,
    type: 'primary',
  },
  {
    label: '删除',
    method: _this.handleDelete,
    type: 'primary',
  },
]
// 表格列配置
const columns = _this => [
  {
    prop: 'name',
    label: '姓名',
    minWidth: 120,
    render: (h, { row }) => {
      return [
        h(
          'p',
          {
            style: {
              color: '#3671BF',
              cursor: 'pointer',
            },
            on: {
              click: () => {
                _this.handleEdit(row)
              },
            },
          },
          row.name,
        ),
      ]
    },
  },
  {
    prop: 'phone',
    label: '手机号码',
    minWidth: 120,
  },
  {
    prop: 'idCard',
    label: '身份证',
    minWidth: 170,
  },
  {
    prop: 'jobRelationList',
    label: '关联职业',
    minWidth: 300,
    render: (h, { row }) => {
      return [row.jobRelationList ? row.jobRelationList.map(item => h('p', item)) : '']
    },
  },
  {
    prop: 'createTime',
    label: '添加时间',
    minWidth: 150,
    sortdata: 1,
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handleLog,
    label: '阅卷记录',
  },
  {
    method: _this.handleAssign,
    label: '分配科目',
  },
]
import TableList from '@/components/TableList'
import { userMarkList, jonWorkTypeList, jonWorkTypeBind, proctorRemove } from '@/api/system'
import to from 'await-to'
import AssignSubject from './assignSubject.vue'
export default {
  name: 'Reviewer',
  components: {
    TableList,
    AssignSubject,
  },
  data() {
    return {
      columns,
      loading: false,
      operates,
      btns,
      reviewerList: [],
      select: [],
      queryParams: {},
      editVisible: false,
      form: {
        jobWorkTypeTag: [],
      },
      jobWorkTypeList: [],
    }
  },
  mounted() {
    this.getList()
    this.getJobWorkTypeList()
  },
  methods: {
    async getList() {
      if (this.loading) return
      this.loading = true
      const [res, err] = await to(userMarkList({ ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.reviewerList = res.data
    },
    async getJobWorkTypeList() {
      const [res, err] = await to(jonWorkTypeList({ ...this.queryParams }))
      if (err) return this.$message.warning(err.msg)
      this.jobWorkTypeList = res.data
    },
    handleSelectionChange(val) {
      this.select = val
    },
    handleAdd() {
      this.$router.push('/system/reviewer/add')
    },
    handleEdit(row) {
      this.form.name = row.name
      this.form.userId = row.userId
      this.form.jobWorkTypeTag = row.jobRelationList
      this.editVisible = true
    },
    handleLog(row) {
      this.$router.push(`/exam/mark?markUserId=${row.userId}`)
    },
    handleAssign(row) {
      this.$refs.AssignSubject.show(row.userId)
    },
    async submit() {
      this.form.userBindJobWorkTypeList = this.form.jobWorkTypeTag.map(
        item => this.jobWorkTypeList.filter(e => e.tag == item)[0],
      )
      const [, err] = await to(jonWorkTypeBind({ relationType: 1, ...this.form }))
      if (err) return this.$message.warning(err.msg)
      this.$message({ type: 'success', message: '修改成功' })
      this.editVisible = false
      this.getList()
    },
    // 删除
    async handleDelete() {
      if (this.select.length == 0) {
        return this.$message.warning('请先选择要删除的阅卷人')
      }
      this.$confirm('你确认要删除吗?', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let idList = []
          this.select.map(v => idList.push(v.id))
          const [, err] = await to(proctorRemove({ idList }))
          if (err) return this.$message({ type: 'error', message: err.msg })
          this.$message({ type: 'success', message: '删除成功' })
          this.getList()
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-select {
  width: 100%;
}
</style>
